import React, { useState, useEffect } from "react";
// Removed Bootstrap imports as requested
import { FaSearch } from "react-icons/fa";
import "./Dashboard.css";
import { API_BASE } from "../apiConfig";

const LIBRARY_API_URL = `${API_BASE}/therapist_api/get_library.php`;

const GuideLibrary = ({ menuOpen, setMenuOpen }) => {

    // State for Guide/Library Data
    const [guideData, setGuideData] = useState([]);

    // State for Search Query
    const [searchQuery, setSearchQuery] = useState("");

    // State to track clicked buttons by ID
    const [clickedItems, setClickedItems] = useState({});

    // Fetch Guide/Library Data
    useEffect(() => {
        const fetchLibraryData = async () => {
            const token = localStorage.getItem("token");

            try {
                const response = await fetch(LIBRARY_API_URL, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch library data");
                }

                const result = await response.json();
                if (result.status && result.data) {
                    setGuideData(result.data);
                }
            } catch (err) {
                console.error("Error fetching library data:", err);
            }
        };

        fetchLibraryData();
    }, []);

    // Resize listener
    useEffect(() => {
        const onResize = () => {
            if (window.innerWidth > 480 && menuOpen) setMenuOpen(false);
        };
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, [menuOpen, setMenuOpen]);

    // Function to handle click on a specific item
    const handleReadMoreClick = (id) => {
        setClickedItems(prevState => ({
            ...prevState,
            [id]: true
        }));
    };

    // Filter logic for title and description
    // Updated to sort alphabetically by title
    const filteredGuideData = guideData.filter((item) => {
        const query = searchQuery.toLowerCase();
        const title = item.title ? item.title.toLowerCase() : "";
        const description = item.description ? item.description.toLowerCase() : "";

        return title.includes(query) || description.includes(query);
    }).sort((a, b) => {
        const titleA = a.title || "";
        const titleB = b.title || "";
        return titleA.localeCompare(titleB);
    });

    return (
        <>

            <div className="GuideLibrary">
                {/* Search Bar */}
                <div className="fixed-header-wrapper">
                    {/* Titles */}
                    <div className="common-page-header">
                        <h1 className="common-page-title" id="guide-library-title">Library</h1>
                        <p className="common-page-subtitle" id="guide-library-subtitle">Learning Reference</p>
                    </div>
                    <div className="search-wrapper1">
                        <label htmlFor="guide-library-search" className="sr-only">Search library guides</label>
                        <input
                            id="guide-library-search"
                            type="search"
                            placeholder="Search"
                            className="rounded-pill search-input1"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            aria-label="Search library guides"
                        />
                        <FaSearch className="search-icon1" aria-hidden="true" />
                    </div>
                </div>

                {/* Cards Scrollable Container */}
                <div className="scrollable-container">
                    <div className="guide-content">
                        {filteredGuideData.map((item, index) => {
                            const cardKey = item.id || `guide-${index}`;
                            return (
                                <article className="card-row" key={cardKey}>
                                    <h2 className="card-row-title">
                                        {item.title || "Untitled guide"}
                                    </h2>
                                    <p className="card-row-desc">
                                        {item.description || "No description available."}
                                    </p>
                                    <div className="card-row-link">
                                        <a
                                            className="link-button"
                                            href={item.page_link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            onClick={() => handleReadMoreClick(item.id)}
                                            aria-label={item.sub_heading ? `Read more: ${item.sub_heading}` : `Read more about ${item.title || "this guide"}`}
                                        >
                                            <span
                                                className="but-1"
                                                style={{ color: clickedItems[item.id] ? "blue" : "#247A33" }}
                                            >
                                                {item.sub_heading}
                                            </span>
                                        </a>
                                    </div>
                                </article>
                            );
                        })}
                    </div>
                </div>
            </div>

        </>
    );
};

export default GuideLibrary;
